import type { IUploadStore } from "./UploadStore";
import type { IUploadCodeAndSourceSelectionStore } from "./content/upload-code-and-source-selection/UploadCodeAndSourceSelectionStore";
import type { IApp, IAppStores } from "../shared-components/AppMaster";
import type { IDicomUploadTusFingerprintStore } from "./DicomUploadTusFingerprintStore";
import type { ICurrentUploadSettingsStore } from "./CurrentUploadSettingsStore";

export interface IAppUpload extends IApp {
    stores: IUploadStores;
}

export class AppUpload implements IAppUpload {
    constructor(public readonly stores: IUploadStores) {}
}

export interface IUploadStores extends IAppStores {
    uploadStore: IUploadStore;
    uploadCodeAndSourceSelectionStore: IUploadCodeAndSourceSelectionStore;
    dicomUploadTusFingerprintStore: IDicomUploadTusFingerprintStore;
    currentUploadSettingsStore: ICurrentUploadSettingsStore;
}
